import { Badge } from 'src/design/atoms/Badge';
import { Paper } from 'src/design/atoms/Paper';
import { Text } from 'src/design/atoms/Text';
import { Title } from 'src/design/atoms/Title';
import { Table } from 'src/design/molecules/Table';
import React from 'react';
import {
  BackgroundJobQueueDto,
  BackgroundJobServerDto,
} from 'src/api/FiretrolApiClient';
import { buildServerQueueRows } from 'src/routes/Settings/BackgroundJobs/serverQueueRows';
import { formatDateTime, formatNumber } from 'src/utils';

export interface IBackgroundJobServersAndQueuesTableProps {
  servers: BackgroundJobServerDto[];
  queues: BackgroundJobQueueDto[];
}

export const BackgroundJobServersAndQueuesTable: React.FC<
  IBackgroundJobServersAndQueuesTableProps
> = ({ servers, queues }) => {
  const rows = React.useMemo(
    () => buildServerQueueRows(servers, queues),
    [servers, queues],
  );

  return (
    <Paper p="md" withBorder>
      <Title order={5} mb="sm">
        Servers and Queues
      </Title>
      {rows.length === 0 ? (
        <Text c="dimmed" size="sm">
          No background job servers or queues are reporting in.
        </Text>
      ) : (
        <Table striped highlightOnHover>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>Queue</Table.Th>
              <Table.Th>Waiting</Table.Th>
              <Table.Th>Fetched</Table.Th>
              <Table.Th>Server</Table.Th>
              <Table.Th>Workers</Table.Th>
              <Table.Th>Started</Table.Th>
              <Table.Th>Heartbeat</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {rows.map((row) => (
              <Table.Tr key={row.key}>
                <Table.Td>{row.queue}</Table.Td>
                <Table.Td>{formatNumber(row.waiting)}</Table.Td>
                <Table.Td>{formatNumber(row.fetched)}</Table.Td>
                <Table.Td>
                  {row.serverName ? (
                    <Text size="xs" ff="monospace">
                      {row.serverName}
                    </Text>
                  ) : (
                    <Badge color="orange" size="sm">
                      No server
                    </Badge>
                  )}
                </Table.Td>
                <Table.Td>
                  {row.workersCount === undefined
                    ? '—'
                    : formatNumber(row.workersCount)}
                </Table.Td>
                <Table.Td>{formatDateTime(row.startedAt) || '—'}</Table.Td>
                <Table.Td>{formatDateTime(row.heartbeat) || '—'}</Table.Td>
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>
      )}
    </Paper>
  );
};
